<template lang="pug">
  div
    component(:is="getCurrentTemplate")
      router-view

    Aside(
      v-if="asideIsOpen({name: 'setting-team-group'})"
      name="setting-team-group"
    )
      template(v-slot="{asideObject}")
        SettingTeamGroupAside(:asideObject="asideObject")

    Aside(
      v-if="asideIsOpen({name: 'distribution-team-group'})"
      name="distribution-team-group"
    )
      template(v-slot="{asideObject}")
        DistributionTeamGroupAside(:asideObject="asideObject")

    Aside(
      v-if="asideIsOpen({name: 'add-team-group'})"
      name="add-team-group"
    )
      template(v-slot="{asideObject}")
        AddTeamGroup(:asideObject="asideObject")

</template>

<script>
import AdminLayout from './Admin';
import LeaderLayout from './Leader';
import UserLayout from './User';

import SettingTeamGroupAside from './components/aside/SettingTeamGroup';
import DistributionTeamGroupAside from './components/aside/DistributionTeamGroup';
import AddTeamGroup from './components/aside/AddTeamGroup';

import asideMixin from '@/mixins/asideMixin';

export default {
  components: {
    AdminLayout,
    LeaderLayout,
    UserLayout,

    //Эсайды
    SettingTeamGroupAside,
    DistributionTeamGroupAside,
    AddTeamGroup
  },
  mixins: [asideMixin],
  data() {
    return {
      userPermissions: ''
    };
  },
  computed: {
    getCurrentTemplate() {
      switch (this.userPermissions) {
        case 'Admin':
          return 'AdminLayout';
        case 'Leader':
          return 'LeaderLayout';
        default:
          return 'UserLayout';
      }
    }
  },
  beforeMount() {
    this.getUserPermissions();
    /* Тут отсылаю запрос на получение прав */
  },
  methods: {
    getUserPermissions() {
      /* Допустим тут получаю права юзверя */
      this.userPermissions = 'Admin';
    }
  }
};
</script>
